import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'rc-tooltip';
import Modal from '../../modal';

import './helpButton.css';

class HelpButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };
    }
    render() {
        const { text, title } = this.props;
        return (
            <div className="help-button">
                <div className="hidden-xs">
                    <Tooltip trigger={'hover'} overlay={<div dangerouslySetInnerHTML={{ __html: text }} />} overlayClassName={'help-button-tooltip'}>
                        <i className="material-icons">help_outline</i>
                    </Tooltip>
                </div>
                <div className="hidden-sm hidden-md hidden-lg">
                    <div onClick={() => this.setState({ modal: true })}>
                        <i className="material-icons">help_outline</i>
                    </div>
                    <Modal title={title} open={this.state.modal} onClose={() => this.setState({ modal: false })} size="col-xs-12">
                        <div className="help-close" onClick={() => this.setState({ modal: false })}>
                            <i class="material-icons"> close</i>
                        </div>
                        <div className="row">
                            <div dangerouslySetInnerHTML={{ __html: text }} />
                        </div>
                    </Modal>
                </div>
            </div>
        );
    }
}

HelpButton.defaultProps = {
    text: undefined
};
HelpButton.propTypes = {
    text: PropTypes.any.isRequired
};

export default HelpButton;



// WEBPACK FOOTER //
// ./src/components/richButtons/helpButton/index.jsx